/** Start of November 16, 2026 in Mountain time: Settings > Reports shows through November 15. */
export const SETTINGS_REPORTS_PAGE_RETIRED_AT = new Date(
  "2026-11-16T07:00:00.000Z",
);

export function isSettingsReportsPageRetired(now: Date): boolean {
  return now.getTime() >= SETTINGS_REPORTS_PAGE_RETIRED_AT.getTime();
}

export function canAccessLabelPurchasesReport({
  isRedoEmployee,
  legacyReportsEnabled,
}: {
  isRedoEmployee: boolean;
  legacyReportsEnabled: boolean;
}): boolean {
  return isRedoEmployee || legacyReportsEnabled;
}
